import axios from 'axios';
import { getAuth } from '../providers/AppAuthProvider';

import { API_BASE_URL as baseUrl } from 'src/utils/api-url';
const resource = 'token/onchain-infos';

export async function findTokenOnchainInfo(address: string, chainId: number) {
  const url = `${baseUrl}/${resource}/${address}:${chainId}`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
  };

  return axios.get<any>(url, {
    headers,
  });
}
